import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {INotification} from "../notification/notification.component";

@Injectable({
  providedIn: 'root'
})
export class AppNotificationService {

  constructor() { }

  public notification$ = new BehaviorSubject<INotification | null>(null);
  // public notification$ = this._notification$.asObservable();

}
